import { useEffect, useRef, useState } from 'react';
import { CSSProperties } from 'styled-components/macro';

export const useIndicator = <T extends string>(
  tabs: readonly { value: T }[],
  activeTab: T
) => {
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [indicatorStyle, setIndicatorStyle] = useState<
    Pick<CSSProperties, 'transform' | 'width'>
  >({ width: 0, transform: 'translateX(0px)' });

  const activeIndex = tabs.findIndex((tab) => tab.value === activeTab);

  useEffect(() => {
    const el = tabRefs.current[activeIndex];

    if (!el) {
      return;
    }

    setIndicatorStyle({
      transform: `translateX(${el.offsetLeft}px)`,
      width: el.offsetWidth,
    });
  }, [activeIndex]);

  return { tabRefs, indicatorStyle, activeIndex };
};
